"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendValidatedDateOfBirth = exports.setDateOfBirth = void 0;
const xstate_1 = require("xstate");
const Events_1 = require("../../../lib/constants/Events");
// Action constant
const setDateOfBirth = '@action/SET_DATE_RESPONSE';
exports.setDateOfBirth = setDateOfBirth;
const sendValidatedDateOfBirth = '@action/SEND_DATE_VALIDATED';
exports.sendValidatedDateOfBirth = sendValidatedDateOfBirth;
const actions = {
    [setDateOfBirth]: (0, xstate_1.assign)({
        dateOfBirth: (_, event) => event.data.dateOfBirth
    }),
    [sendValidatedDateOfBirth]: (0, xstate_1.sendParent)((context) => {
        return {
            type: Events_1.DATE_VALIDATED,
            data: {
                validatedDateOfBirth: context.dateOfBirth
            }
        };
    })
};
exports.default = actions;
//# sourceMappingURL=actions.dobConfirmationMachine.js.map